import { Record } from 'immutable';
import { Err } from '../err';

/**
 * This is the standardized format to represent the data associated with making an api call
 * api call information that is needed in any reducer can innitialize their information using this structure
 * err: data representing an error from the Participant Portal API, the value is null if no error has occurred
 * isFetching: true if the api call is in progress, false if it is not
 * isValid: true if the api call is completed and is in a valid state false if the call is in progress or the data has been invalidated by some other operation
 * data: the data associated with the api call, it is null if no data has been loaded yet
 */
export const ApiCallState = Record({
  err: null,
  isFetching: false,
  isValid: false,
  data: null
});

/**
 * This function acts as a helper to a parent reducer.
 * It manages the state of api call information of the parent, specifically isFetching, isValid, err, and data information.
 * The result of this function should be used to set the subsection of the parent's state that this is supposed to manage
 * @param {object} state this is the subsection of the parent reducer that deals specifically with paging
 * @param {object} action this is the action that the parent reducer is currently processing
 * @param {object} fetchActions an object expected to be in the format that is produced by the fetchActions function in fetch-actions.js
 * @param {array} invalidateActions an array of action types that should cause the ApiCallState to be invalidated (a.k.a. should trigger the data to reload)
 * @returns a modified version of the given state
 */
export const apiCallReducer = (state = new ApiCallState(), action, fetchActions, invalidateActions = []) => {
  var invalidateState = false;
  invalidateActions && invalidateActions.forEach(type => {
    if(action.type === type)
      invalidateState = true;
  });

  var modifiedState = state;
  if(invalidateState)
    modifiedState = state.set('isValid', false);

  switch (action.type) {
    case fetchActions.begin:
      return new ApiCallState({
        isFetching : true
      });
    case fetchActions.success:
      return new ApiCallState({
        data: action.data,
        isValid: true
      });
    case fetchActions.failure:
      return new ApiCallState({
        err: new Err(action.err),
        isValid: true
      });
    default:
      return modifiedState;
  }
}



// WEBPACK FOOTER //
// src/api/fetch-reducer.js